<template>
  <section class="app-main">
    <!-- 全局相关问题 -->
    <div class="issue">
      <el-popover placement="bottom" trigger="manual" v-model="visible" width="300">
        <div class="custom-title">
          <span class="">相关问题</span>
          <el-button type="text" class="close-btn" @click="handleClose">
            <i class="el-icon-close"></i>
          </el-button>
        </div>
        <div v-for="item, index in isIssueList" :key="index" style="display:flex;align-items: center;margin-top:7px">
          <img src="@/assets/imgs/issue.png" alt="" width="14" height="14">
          <span class="itemIssue" @click="handleIssue(item.id)">{{ item.title }}</span>
        </div>
        <div class="bottomBtn">
          <el-button type="text" size="mini" @click="handleMore">查看更多＞</el-button>
          <div>
            <el-checkbox v-model="checkedRemind" @change="changeRemind"></el-checkbox>
            <span>不再提醒</span>
          </div>
        </div>
        <el-button type="text" slot="reference" v-show="isIssueList.length"
          @click="visible = !visible">相关问题＞</el-button>
      </el-popover>
    </div>
    <transition name="fade-transform" mode="out-in">
      <keep-alive :include="cachedViews">
        <router-view :key="key" />
      </keep-alive>
    </transition>
    <div class="footers">
      <div class="title mb15" v-text="copyright"></div>
    </div>
  </section>
</template>

<script>
import * as Api from '@/api/helpCenter.js'
import { EventBus } from '@/utils/eventBus';
export default {
  name: 'AppMain',
  data () {
    return {
      links: [
        {
          title: '官网',
          key: '1',
          href: 'https://www.crmeb.com',
          blankTarget: true
        },
        {
          title: '社区',
          key: '2',
          href: 'http://bbs.crmeb.net',
          blankTarget: true
        },
        {
          title: '文档',
          key: '3',
          href: 'https://help.crmeb.net',
          blankTarget: true
        }
      ],
      copyright: 'Copyright © 2021 南京研精致思智能科技有限公司',
      visible: false,
      checkedRemind: false,
      issueListL: [], // 全部问题列表
      isIssueList: [],  // 当前页面问题列表
      remindList: JSON.parse(localStorage.getItem("skipReminders") || "[]"),  // 缓存的不在提醒列表
    }
  },
  computed: {
    cachedViews () {
      // console.log(this.$store.state.tagsView.cachedViews);

      return this.$store.state.tagsView.cachedViews
    },
    key () {
      return this.$route.path
    }
  },
  created () {
    // 监听事件
    EventBus.$on('data-key', (data) => {
      this.visible = false
      this.checkedRemind = false
      this.getRouter(data)
    });
  },
  mounted () {
    this.getShowProblem()
  },
  methods: {
    // 获取问题列表
    async getShowProblem () {
      await Api.showProblem().then(res => {
        this.issueList = res
        this.getRouter(this.$route.path)
      })
    },
    // 获取当前页面问题
    getRouter (path) {
      this.isIssueList = []
      const b = this.issueList.flatMap(item =>
        item.problem.flatMap(problem => {
          // 如果 url 为空字符串，直接返回空数组，过滤掉该对象
          if (problem.shopUrl === "") return [];
          // 如果 url 包含分号，则分割，否则直接返回一个元素的数组
          const urls = problem.shopUrl.includes(";") ? problem.shopUrl.split(";") : [problem.shopUrl];
          return urls.map(url => ({
            url: url.trim(),
            title: problem.title,
            id: problem.id
          }));
        })
      );
      for (let i = 0; i < b.length; i++) {
        if (path == b[i].url) {
          this.isIssueList.push(b[i])
        }
      }
      this.getRemind(path)
    },
    // 判断是否显示弹窗
    getRemind (path) {
      if (this.remindList.includes(path)) {
        this.checkedRemind = true
        this.visible = false
        return
      }
      if (this.isIssueList.length != 0) {
        this.visible = true
      }
    },
    // 跳转到帮助中心
    handleIssue (id) {
      let url = window.document.location.origin
      const urls = url + `/helpCenter?id=${id}`
      window.open(urls)
    },
    handleClose () {
      this.visible = false
    },
    handleMore () {
      let url = window.document.location.origin
      const urls = url + `/helpCenter`
      window.open(urls)
    },
    // 新增、删除不再提醒
    changeRemind () {
      if (this.checkedRemind) {
        this.remindList.push(this.$route.path)
        localStorage.setItem("skipReminders", JSON.stringify(this.remindList))
      } else {
        this.remindList = this.remindList.filter(item => item !== this.$route.path)
        localStorage.setItem("skipReminders", JSON.stringify(this.remindList))
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.footers {
  text-align: center;
  font-size: 14px;
  color: #808695;

  .title {
    font-size: 14px;
    color: #808695;
  }
}

.app-main {
  /* 50= navbar  50  */
  min-height: calc(100vh - 50px);
  width: 100%;
  position: relative;
  overflow: hidden;
}

.fixed-header+.app-main {
  padding-top: 95px;
}

.hasTagsView {
  .app-main {
    background: #f5f5f5;
    /* 84 = navbar + tags-view = 50 + 34 */
    min-height: calc(100vh - 84px);
  }

  .fixed-header+.app-main {
    padding-top: 95px;
  }
}

.el-popup-parent--hidden {
  .fixed-header {
    padding-right: 15px;
  }
}

.issue {
  text-align: right;
  font-size: 14px;
  font-family: PingFangSC-regular;
  margin: 0px 20px 0 0;


}

.itemIssue {
  display: inline-block;
  margin-left: 3px;
  font-size: 13px;
  text-align: left;
  font-family: SourceHanSansSC-regular;
  cursor: pointer;
}

.itemIssue:hover {
  color: #1890ff;
  text-decoration: underline;
}

.bottomBtn {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;

  span {
    font-size: 12px;
    font-family: SourceHanSansSC-regular;
  }
}

.custom-title {
  display: flex;
  justify-content: space-between;
  align-items: center;

  span {
    color: rgba(0, 0, 0, 1);
    font-size: 16px;
    font-family: SourceHanSansSC-bold;
  }
}

.close-btn {
  padding: 0;
  font-size: 16px;
}
</style>
